import type { LocationState } from "./useLocation";
import { accuracyLabel } from "./useLocation";

type Props = { state: LocationState; compact?: boolean };

/**
 * Always-visible badge showing current location accuracy while broadcasting.
 * Stays in the broadcaster's view so they know newsroom location metadata is active.
 */
export default function LocationBadge({ state, compact }: Props) {
  const p = state.current;
  if (!p) {
    return (
      <div className="loc-badge loc-badge--err">
        <span className="loc-badge__dot" />
        No location
      </div>
    );
  }
  const acc = accuracyLabel(p.accuracyM);
  return (
    <div className={`loc-badge loc-badge--${acc.tier}`} title="Live location is being shared with the newsroom">
      <span className="loc-badge__dot" />
      📍 {p.lat.toFixed(5)}, {p.lon.toFixed(5)}{!compact && ` · ${acc.label}`}
      {state.error && <span className="loc-badge__warn" title={state.error}>!</span>}
    </div>
  );
}
